import type {
  ReportDeliveryCreateDto,
  ReportDeliveryUpdateDto,
} from "@/types/delivery"
import {
  DEFAULT_DELIVERY_TYPE_KEY,
  DEFAULT_FILE_TYPE_KEY,
  DEFAULT_COLLATION_TYPE_KEY,
} from "./constants"

export function createDefaultDeliveryDto(
  overrides: Partial<ReportDeliveryCreateDto> & {
    createdUserKey: string
    tenantId: number
  }
): ReportDeliveryCreateDto {
  return {
    reportDeliveryTypeKey: DEFAULT_DELIVERY_TYPE_KEY,
    fileName: "",
    filePath: "",
    reportFileTypeKey: DEFAULT_FILE_TYPE_KEY,
    reportCollationTypeKey: DEFAULT_COLLATION_TYPE_KEY,
    emailTo: "",
    emailCC: "",
    emailFrom: "",
    emailReplyTo: "",
    emailSubject: "",
    emailMessage: "",
    printerName: "",
    printerPath: "",
    ...overrides,
  }
}

export function createDefaultDeliveryUpdateDto(
  overrides: Partial<ReportDeliveryUpdateDto> & {
    reportDeliveryKey: string
    createdUserKey: string
    lastModifiedUserKey: string
    tenantId: number
  }
): ReportDeliveryUpdateDto {
  return {
    ...createDefaultDeliveryDto({
      createdUserKey: overrides.createdUserKey,
      tenantId: overrides.tenantId,
    }),
    ...overrides,
  }
}
